import { RenderComponentStrategy } from './render-component.strategy';

export class HorizontalBrace extends RenderComponentStrategy {
	componentKey = 'Stiffening_rib003';
}
